<template>
  <v-dialog
    v-model="dialog"
    :max-width="showFilerList ? 600 : 350"
    :fullscreen="$vuetify.display.xs"
    v-bind="$vuetify.display.xs ? { transition: 'dialog-bottom-transition' } : {}"
    persistent
  >
    <template #activator="{ props }">
      <v-btn
        :disabled="!user || !user.id || !filerGroup || !filerGroup.filers.length"
        :small="$vuetify.display.xs"
        color="primary"
        class="ma-0"
        v-bind="props"
      >
        {{ btnText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-toolbar-title>
          {{ !filerGroup || !filerGroup.id ? 'Create group' : 'Update group' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn variant="text" :icon="mdiClose" class="ma-0 float-end" @click="closeDialog()">
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm" lazy-validation @submit.prevent="createGroup()">
          <v-text-field
            ref="groupNameField"
            v-model="groupName"
            :rules="groupNameRules"
            clearable
            label="Group name"
            @keyup.enter="createGroup()"
            @keyup.esc="closeDialog()"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer />
        <v-btn
          :loading="saving"
          :disabled="saving || !validForm"
          depressed
          color="primary"
          @click="createGroup()"
        >
          Submit
        </v-btn>
      </v-card-actions>
      <v-card-text v-if="showFilerList">
        <helpers-section-sub-header class="mb-2">
          The new group will have the following members
          <span class="text-grey">({{ filerGroup.filers.length }})</span>:
        </helpers-section-sub-header>
        <v-chip
          v-for="filer in filerGroup.filers"
          :key="filer.id"
          small
          label
          color="primary text-white"
        >
          {{ filer.name }}
        </v-chip>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import { mapStoreState } from '@/store/helpers'
import { mdiClose } from '@mdi/js'

export default {
  props: {
    filerGroup: {
      type: Object,
      required: true
    },
    local: Boolean,
    showFilerList: Boolean
  },
  emits: ['update:filerGroup'],
  data() {
    return {
      mdiClose: mdiClose,
      dialog: false,
      saving: false,
      validForm: false,
      groupName: null,
      groupNameRules: [
        v => !!v || 'Group name is required',
        v => (v && v.length >= 2) || 'Group name must be at least 2 characters'
      ]
    }
  },

  computed: {
    ...mapStoreState({
      user: state => state.user.user,
      groups: state => state.user.groups
    }),

    btnText() {
      if (!this.user || !this.user.id) return 'Log in to save'
      else if (!this.filerGroup || !this.filerGroup.id) return 'Create group'
      else return 'Update group'
    }
  },

  watch: {
    dialog(isVisible) {
      if (isVisible) {
        this.groupName = this.filerGroup.description
        this.$nextTick(() => this.$refs.groupNameField.focus())
      }
    }
  },

  methods: {
    createGroup() {
      if (this.$refs.form.validate()) {
        const group = {
          ...this.filerGroup,
          description: this.groupName
        }
        let url = 'groups'

        if (group.id) url += `/${group.id}.json`

        this.saving = true

        api
          .post(url, group)
          .then(response => {
            useUserStore()
              .loadGroups()
              .then(() => {
                const foundGroup = this.groups.find(g => g.id === response.data.id)

                if (this.local) {
                  this.$emit('update:filerGroup', foundGroup)
                } else {
                  useAppStore().setSelectedGroup(foundGroup)
                }
              })
            useAppStore().showNotification({
              type: 'success',
              text: `Saved group ${group.description}, consisting of ${group.filers.length} funds.`
            })
            this.closeDialog()
          })
          .catch(error => {
            useAppStore().showNotification({
              type: 'error',
              text: (error.response && error.response.data) || error.message
            })
          })
          .then(() => (this.saving = false))
      }
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form.reset()
    }
  }
}
</script>
